import React from "react";

import HeaderStickyDropdown from "@/components/common/Header/HeaderStickyDropdown";
import Logo from "@/components/common/Logo";
import { ArrowUpIcon } from "@/components/icons/ArrowUpIcon";
import { cn } from "@/utils/general";
import { scrollToTop } from "@/utils/general";
import { ThemeTypes } from "@/utils/theming";

export interface HeaderStickyProps {
  theme: ThemeTypes;
  useOneTimeOption?: boolean;
  handleNavLogoExitClick: () => void;
}

const HeaderSticky: React.FC<HeaderStickyProps> = ({
  handleNavLogoExitClick,
  theme,
  useOneTimeOption = false,
}) => {
  const isMen = theme === "men";
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      className="bg-nova-base-white flex items-center h-full px-.5 md:px-4 lg:px-6 lg:rounded"
      onClick={handleClick}
    >
      <div
        className={cn(
          `hidden md:block lg:pt-1.5`,
          isMen ? "lg:w-[calc(50%-91px)]" : "lg:w-[calc(50%-78px)]"
        )}
      >
        <button onClick={scrollToTop} aria-label="Scroll to top">
          <ArrowUpIcon className="text-nova-base-solid-40" />
        </button>
      </div>
      <div className={cn("hidden lg:block lg:pt-1.5", isMen ? "lg:w-[182px]" : "lg:w-[156px]")}>
        <button onClick={handleNavLogoExitClick} aria-label="Logo">
          <Logo theme={theme} />
        </button>
      </div>
      <div
        className={cn(
          "ml-auto flex justify-end w-full",
          isMen ? "lg:w-[calc(50%-91px)]" : "lg:w-[calc(50%-78px)]"
        )}
      >
        <HeaderStickyDropdown useOneTimeOption={useOneTimeOption} />
      </div>
    </div>
  );
};

export default HeaderSticky;
